import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

function BackToTopIcon({ width = 24, height = 24 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ transform: 'rotate(0deg)' }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5316 4.2099C12.391 4.06925 12.2002 3.99024 12.0013 3.99024C11.8024 3.99024 11.6116 4.06925 11.4709 4.20991L5.10698 10.5739C4.81409 10.8668 4.81409 11.3416 5.10698 11.6345C5.39988 11.9274 5.87475 11.9274 6.16764 11.6345L11.305 6.49718L11.305 18.9048C11.305 19.319 11.6408 19.6548 12.055 19.6548C12.4692 19.6548 12.805 19.319 12.805 18.9048L12.805 6.60461L17.8349 11.6345C18.1278 11.9274 18.6027 11.9274 18.8956 11.6345C19.1885 11.3416 19.1885 10.8668 18.8956 10.5739L12.5316 4.2099Z"
        fill="black"
      />
    </svg>
  );
}

export default BackToTopIcon;
